import {
  ICompletedSection,
  IIntroduction,
  IOtherDescription,
  IRemark,
} from '@Domains/utils';
import useAxios from 'axios-hooks';
import { Dayjs } from 'dayjs';
import { EsgProvidePercentLanguage } from 'src/Enum/EsgPlatform';

interface IEsgDataPlatformOverview {
  introduction?: IIntroduction;
  remark?: IRemark;
}
export interface IEsgStatus {
  percentageTh?: number;
  percentageEn?: number;
  lastUpdateTh: Dayjs | string;
  lastUpdateEn: Dayjs | string;
  hasEsgPercentTh: boolean;
  hasEsgPercentEn: boolean;
}

export interface IEsgDataPlatform {
  esgDataPlatform: IEsgDataPlatformOverview;
  esgStatus?: IEsgStatus;
  otherDescriptions?: Array<IOtherDescription>;
  completedSection?: ICompletedSection;
}

export interface IProvidePercentEsg {
  reportId?: number;
  language?: EsgProvidePercentLanguage;
}

export const useSaveEsgDataPlatform = (
  reportId?: string,
  payload?: IEsgDataPlatform
) => {
  return useAxios<IEsgDataPlatform>(
    {
      method: 'POST',
      url: `/esg-plans/platform/${reportId}`,
      data: payload,
    },
    { manual: true }
  );
};

export const useGetEsgDataPlatform = (
  reportId?: string,
  isPublished?: boolean
) => {
  const endpoint = isPublished
    ? `/esg-plans/platform/${reportId}/published`
    : `/esg-plans/platform/${reportId}`;

  return useAxios<IEsgDataPlatform>({
    url: endpoint,
  });
};
